module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Cake-9a5ac4a7558a0279ace1a8aca94e9c18.svg";